
import Aave from "../../../assets/filled/Aave.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AaveIcon({ className, dataTestid = "AaveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Aave data-testid={dataTestid} className={classes} {...rest} />
  );
}
